/* ─── SSW Theme tokens ───────────────────────────────
   Import this in any component:
   import { t, ts } from '../../theme';
─────────────────────────────────────────────────── */

export const t = {
    primary: '#2b3f8c',   // main brand blue
    primaryLight: '#eef1fa',   // soft blue bg
    primaryMid: '#b8c3e8',   // border / hover
    primaryText: '#1a2a6b',   // dark blue text on light bg

    text: '#111827',
    textSub: '#6b7280',
    textHint: '#9ca3af',

    border: '#e2e2e2',
    borderInput: '#d1d5db',
    surface: '#f9fafb',
    white: '#fff',

    danger: '#E24B4A',
    dangerLight: '#FEF2F2',
    dangerBorder: '#FECACA',
    dangerText: '#A32D2D',

    radius: {
        sm: 6,
        md: 8,
        lg: 12,
    },
};

/* Shorthand style builders */
export const ts = {
    input: {
        height: 34,
        border: `0.5px solid ${t.borderInput}`,
        borderRadius: t.radius.md,
        padding: '0 10px',
        fontSize: 13,
        color: t.text,
        background: t.white,
        outline: 'none',
        width: '100%',
    },
    label: {
        display: 'block',
        fontSize: 12,
        fontWeight: 500,
        color: t.textSub,
        marginBottom: 4,
    },
    sectionLabel: {
        fontSize: 11,
        fontWeight: 500,
        color: t.textHint,
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        margin: '1.25rem 0 0.75rem',
        paddingBottom: 6,
        borderBottom: `0.5px solid ${t.border}`,
    },
    card: {
        background: t.white,
        border: `0.5px solid ${t.border}`,
        borderRadius: t.radius.lg,
    },
    iconWrap: {
        width: 36,
        height: 36,
        borderRadius: t.radius.md,
        background: t.primaryLight,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    btnPrimary: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '8px 20px',
        fontSize: 13,
        fontWeight: 500,
        borderRadius: t.radius.md,
        background: t.primary,
        color: t.white,
        border: 'none',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
    },
    btnGhost: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '8px 16px',
        fontSize: 13,
        fontWeight: 500,
        borderRadius: t.radius.md,
        background: t.surface,
        color: t.textSub,
        border: `0.5px solid ${t.borderInput}`,
        cursor: 'pointer',
        whiteSpace: 'nowrap',
    },
    btnDanger: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '8px 16px',
        fontSize: 13,
        fontWeight: 500,
        borderRadius: t.radius.md,
        background: t.dangerLight,
        color: t.dangerText,
        border: `0.5px solid ${t.dangerBorder}`,
        cursor: 'pointer',
        whiteSpace: 'nowrap',
    },
    badge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        padding: '3px 12px',
        background: t.primaryLight,
        borderRadius: 20,
        fontSize: 12,
        fontWeight: 500,
        color: t.primaryText,
        border: `0.5px solid ${t.primaryMid}`,
        whiteSpace: 'nowrap',
    },
};